<template>
  <div class="wg-open-hours">
    <div class="themesflat-container">
      <div class="row">
        <div class="col-lg-7">
          <div class="image">
            <img
              style="height: 564px; object-fit: cover"
              class="w-full"
              :src="getImageUrl(openHour.image)"
              alt=""
            />
          </div>
        </div>
        <div class="col-lg-5 d-flex align-items-center">
          <div class="content">
            <div class="heading-section">
              <div class="main " :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ openHour.title }}</div>
              <div class="description ">
                {{ openHour.small_description }}
              </div>
            </div>
            <ul class="list-content">
              <li class="">
                <p class="text">{{ $t("opening_time") }}:</p>
              </li>
              <li class="">
                <p>
                  {{ $t("monday") }} - {{ $t("sunday") }} :
                  {{ openHour.open_time_hours_from }} -
                  {{ openHour.open_time_hours_to }}
                </p>
              </li>
              <li class="">
                <p>
                  {{ $t("delivery") }}: {{ openHour.delivery_time_from }} -
                  {{ openHour.delivery_time_to }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "OpenHoursComponent",
  props: {
    msg: String,
  },
  data() {
    return {
      langStore,
      openHour: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchOpenHours();
    },
  },

  mounted() {
    this.fetchOpenHours();
  },

  methods: {
     async fetchOpenHours() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/open-hour`,
          { params: { lang: this.langStore.lang } }
        );

        this.openHour = response.data;

        // WAIT FOR IMAGES TO LOAD
        this.waitForImages();
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },
    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + photo;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
